const identity = {
  logo: {
    height: 40,
    width: 100,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain'
  }
}

export default identity
